import styled from 'styled-components'

import { MediaBreakpoint } from 'root-constants'

export const StyledHolidayBackdrop = {
  Root: styled.div`
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  Wrapper: styled.div`
    width: 100%;
    max-width: 560px;
    overflow: hidden;
    max-height: 100%;
    @media (min-width: ${MediaBreakpoint.TABLET}px) {
      margin-left: 60px;
    }
  `,
}
